import { PartialSanityImageType } from "@silversea-ssc/ui-components-react";
import useLiveSanityContent, {
  UseLiveSanityContentResponse
} from "../../utils/useLiveSanityContent";

interface RemotePrePostHotelModalContent {
  _key: string;
  descriptionHtml: string;
  image?: PartialSanityImageType;
}

export const usePrePostHotelModalContent = (
  type: "SanityHotel" | "SanityLandProgramme",
  code: string | undefined
): UseLiveSanityContentResponse<RemotePrePostHotelModalContent> => {
  const sanityType = type == "SanityLandProgramme" ? "landProgramme" : "hotel";

  const query = `
      *[_type == "${sanityType}" && code == "${code}"]
      {
        _key,
        descriptionHtml,
        image{
          asset->{
            _id,
            assetId,
            url,
            extension,
            metadata{dimensions}
          }
        }
      }[0]
    `;

  return useLiveSanityContent<RemotePrePostHotelModalContent>(query);
};
